import { Drawer, SimpleToolbar } from "../../components";
import {
  Grid,
  Container,
  makeStyles,
  Box,
  Button,
} from "@material-ui/core";
import { useDrawer } from "../../hooks";
import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
import TouchAppRoundedIcon from "@material-ui/icons/TouchAppRounded";
import AssignToDoctor from "./assign-to-doctor";
import { useState } from "react";
import AssignToDoctorByFile from "./assign-to-doctor-by-file";
export default function AssignToDoctorScreen() {
  const classes = useStyles();
  const { isOpen, setIsOpen } = useDrawer();
  const [assignBy, setAssignBy] = useState("flow"); // flow||file

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
            <Box className={classes.tabs}>
              <Button
              size="small"
                onClick={() => setAssignBy("flow")}
                className={classes.tab}
                data-state={assignBy === "flow" ? "active" : ""}
                startIcon={<TouchAppRoundedIcon />}
              >
                Manual
              </Button>
              <Button
              size="small"
                className={classes.tab}
                onClick={() => setAssignBy("file")}
                data-state={assignBy === "file" ? "active" : ""}
                startIcon={<BackupOutlinedIcon />}
              >
                Automático
              </Button>
            </Box>
          </Container>
          {assignBy === "flow" ? <AssignToDoctor /> : <AssignToDoctorByFile />}
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    minHeight: "100vh",
    paddingBlock:16
  },
  content: {
    display: "flex",
    flexDirection: "column",
    "& main": {
      flexGrow: 1,
    },
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
  tabs: {
    display: "flex",
    justifyContent: "start",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
    paddingInline: 12,
    marginTop:12
  },
  tab: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingInline: 18,
    color: theme.palette.grey[600],
    '&[data-state="active"]': {
      border: `1px solid ${theme.palette.secondary.dark}`,
      borderBottom: "none",
      color: theme.palette.secondary.dark,
    },
  },
}));
